import axios from '@/api/axios.config'

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const getFloralArrangements = async (caseId: string) => {
  return await axios.get(`floralArrangements?case_id=${caseId}`)
}
